const printImage = {
    init() {
        const triggers = document.querySelectorAll('.js-print-trigger');
        triggers.forEach((trigger) => {
            trigger.addEventListener('click', () => {
                const imageSrc = trigger.dataset.img;
                const html = `<html>
                        <head>
                            <script>
                            function step1() {
                                setTimeout('step2()', 10);
                            }
                            
                            function step2(){
                                window.print();
                                window.close()
                            }
                            </script>
                        </head>
                        <body onload="step1()">
                            <img src="${imageSrc}"/>
                        </body>
                    </html>`;

                const target = 'about:blank';
                const page = window.open(target, '_new');
                page.document.open();
                page.document.write(html);
                page.document.close();
            });
        });
    },
};

export default printImage;
